import Dropdown from "app/components/Dropdown";
import NewInput from "app/components/NewInput";
import SlabVsBrands from "./SlabVsBrands";
import SlabVsEarnedPoints from "./SlabVsEarnedPoints";
import SlabVsMember from "./SlabVsMember";
import SlabVsUsedPoints from "./SlabVsUsedPoints";
import "./index.scss";
import useGraphAnalylitics from "./useGraphAnalylitics";

const GraphAnalytics = () => {
    const {   
        values,  
        mallList,
        setChange,
        setChangegetvalue,    
      } = useGraphAnalylitics();
     
  return (
    <>
    <div className='inner-form-wrapper flex justify-between flex-wrap mb-4'>
     
    <div className='wd-50'>
    <Dropdown
        id={'mallId'}
        label='Mall name*'
        name='mallId'
        options={mallList?mallList:[]}
        placeholder='Select Mall '
        value={values?.mallId?values?.mallId:null }
        handleChange={setChange}
       
      />
</div>
   <div className='wd-25'>
    <NewInput
        label='Start Date*'
        id='startDate'
        placeholder='DD-YY-MMMM'
        name='startDate'
        format='DD-MM-YYYY'
        type={'date'}
        max={values.endDate && values.endDate}
        value={values?.startDate}
        onChange={setChange}
      />
    </div>
    <div className='wd-25'>
      <NewInput
        label='End Date*'
        name='endDate'
        id='endDate'
        placeholder={'End Date'}
        min={values.startDate&& values.startDate }  
        value={values?.endDate}
        type={'date'}
        onChange={setChangegetvalue}
      />
    </div>
    {/* <div className='wd-25'>
    <Button
             className='mt1 mt-4'
             onClick={handleSubmit}
             variant='Save'
             name='Submit'
             isDisabled={!values.mallId || !values.startDate || !values.endDate}
           />
           </div> */}
           <div>
         
           </div>
    </div>  
    <div className="graph-analytics-container">
  <div className="report report-1"><SlabVsEarnedPoints values={values} /></div>
  <div className="report report-2"><SlabVsUsedPoints values={values} /></div>
  <div className="report report-3"><SlabVsMember values={values} /></div>
  <div className="report report-4"><SlabVsBrands values={values} /></div>
</div>

    </>
  );
};

export default GraphAnalytics;
